import { Tab, Tabs } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import SocialWelfare from './socialWelfare';
import CollectiveAgreement from './collectiveAgreement';

const AbsenceSettingTabs = (props) => {
    const { t, handleUserDataChange, handleClientRuleChange } = props;

    return (
        <div className='mt-2'>
            <Tabs defaultActiveKey="collectiveAgreement" id="MainTabContainer">
                <Tab eventKey="collectiveAgreement" title={t('Collective Agreement')}>
                    <CollectiveAgreement
                        handleUserDataChange={handleUserDataChange}
                        handleClientRuleChange={handleClientRuleChange} />
                </Tab>
                <Tab eventKey="socialWelfare" title={t('Social Welfare')}>
                    <SocialWelfare
                        handleUserDataChange={handleUserDataChange}
                        handleClientRuleChange={handleClientRuleChange} />
                </Tab>
            </Tabs>
        </div>
    )
}

export default withLocalization(AbsenceSettingTabs);